import Vue from 'vue'
import Main from './Confirm.vue'
const ConfirmConstructor = Vue.extend(Main)

const Confirm = async function(options) {
    options = options || {}

    return new Promise((resolve, reject) => {
        var instance = new ConfirmConstructor({
            data: options,
            propsData: {
                resolve,
                reject
            }
        })
        instance.$mount()
    })
}

export default Confirm
